import DeferredPromise from "./DeferredPromise";
import i18n from "i18next";
import { providerScripts } from "@kubera/common";

const scriptConfig = {
  [providerScripts.YODLEE]: {
    id: "yodlee-script",
    src: "https://cdn.yodlee.com/fastlink/v4/initialize.js"
  },
  [providerScripts.PLAID]: {
    id: "plaid-script",
    src: "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
  },
  [providerScripts.FINICITY]: {
    id: "finicity-script",
    src: "https://connect2.finicity.com/assets/sdk/finicity-connect.min.js",
    readyGlobal: "finicityConnect"
  },
  [providerScripts.TREZOR]: {
    id: "trezor-script",
    src: "https://connect.trezor.io/9/trezor-connect.js"
  },
  [providerScripts.RECAPTCHA_V2]: {
    id: "recaptcha-v2-script",
    src: "https://www.google.com/recaptcha/api.js?onload=onRecaptchaV2Load&render=explicit",
    readyCallback: "onRecaptchaV2Load"
  },
  [providerScripts.RECAPTCHA_V3]: {
    id: "recaptcha-v3-script",
    src: `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_ID}`
  },
  [providerScripts.META_PIXEL]: {
    id: "meta-pixel-script",
    src: "https://connect.facebook.net/en_US/fbevents.js"
  }
};

const loadPromises = {};

const READY_CALLBACK_TIMEOUT_MS = 10000;

const loadProviderScript = name => {
  if (loadPromises[name]) {
    return loadPromises[name];
  }

  const config = scriptConfig[name];
  const loadPromise = new DeferredPromise();
  loadPromises[name] = loadPromise;

  const existingScript = document.getElementById(config.id);
  const script = existingScript || document.createElement("script");

  let isSettled = false;
  const resolveLoad = () => {
    if (isSettled) {
      return;
    }
    isSettled = true;
    loadPromise.resolve(true);
  };
  const rejectLoad = () => {
    if (isSettled) {
      return;
    }
    isSettled = true;
    delete loadPromises[name];
    script.remove();
    try {
      loadPromise.reject(i18n.t("linkingProviderScriptLoadError"));
    } catch (err) {}
  };

  if (existingScript) {
    const isLoaded = window.__kuberaProviderScriptLoaded?.[config.id];
    if (isLoaded === true || window[config.readyGlobal]) {
      resolveLoad();
    } else if (isLoaded === false) {
      rejectLoad();
    } else {
      script.addEventListener("load", resolveLoad);
      script.addEventListener("error", rejectLoad);
    }
    return loadPromise;
  }

  script.id = config.id;
  script.async = true;

  if (config.readyCallback) {
    window[config.readyCallback] = resolveLoad;
    script.addEventListener("load", () => setTimeout(rejectLoad, READY_CALLBACK_TIMEOUT_MS));
  } else {
    script.addEventListener("load", resolveLoad);
  }

  script.addEventListener("error", rejectLoad);

  script.src = config.src;
  document.body.appendChild(script);

  return loadPromise;
};

window.loadProviderScript = loadProviderScript;

export default loadProviderScript;
